import type { SymptomFrequency } from '@pelvia/shared/hooks/patient/usePainPatterns'

/**
 * 30-day symptom counts as ranked horizontal bars (each relative to the most
 * frequent symptom). Renders nothing until at least one symptom is logged.
 */
export default function SymptomFrequencyCard({
  frequency,
}: {
  frequency?: SymptomFrequency
}) {
  if (!frequency || frequency.items.length === 0) return null

  const maxCount = frequency.items[0].count || 1

  return (
    <section className="card">
      <h3 className="pp-card-title">Symptoms (30 days)</h3>
      <p className="pp-card-desc">How often each symptom shows up.</p>
      {frequency.items.map((it) => {
        const pct = (it.count / maxCount) * 100
        return (
          <div key={it.symptom} className="pp-symptom-row">
            <div className="pp-symptom-label">{it.label}</div>
            <div className="pp-symptom-track">
              <div className="pp-symptom-fill" style={{ width: `${pct}%` }} />
            </div>
            <div className="pp-symptom-count">{it.count}</div>
          </div>
        )
      })}
    </section>
  )
}
